export default defineNuxtRouteMiddleware(() => {
  const { isOpen } = useNavigation()
  isOpen.value = {}
})
